
import { useNavigate, useParams } from "react-router-dom";
import { Section } from "../components/styled/Containers.style";
import { PageTitle, TextDefault } from "../components/styled/Text.style";
import { Vspace } from '../components/styled/Separators.style'
import { composeUrl } from "../utils/utils";
import { PATHS } from "../routes/CaiExperienceRouter";
import PageContainerCmp from "./PageContainerCmp";
import FotoAngolareVeicolo from "../components/foto-angolare-veicolo/FotoAngolareVeicolo";
import { useAppSelector } from "../store/hooks";
import { selectCommunicationData } from "../store";

/* istanbul ignore next */
const Trct_FotoAngolareTuoVeicoloPage = () => {
    let navigate = useNavigate();
    let { token } = useParams();
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const nextBtnDisabled = !communication?.fotoAngolareVeicolo || communication.fotoAngolareVeicolo.length < 4;

    const goToNextStepHandler = () => {
        navigate(composeUrl(token, PATHS.TRCT_FOTO_CRUSCOTTO))
    }

    return (
        <>
            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={PATHS.TRCT_FOTO_ANGOLARE_TUO_VEICOLO}
                nextDisabled={nextBtnDisabled}
            >
                <>
                    <Section>
                        <PageTitle>Foto del tuo veicolo</PageTitle>
                        <Vspace></Vspace>
                        <TextDefault centered>Scatta una foto da ogni angolo del veicolo. Assicurati che la targa risulti visibile in almeno una foto.</TextDefault>
                    </Section>

                    <FotoAngolareVeicolo />
                </>
            </PageContainerCmp>
        </>

    )
}

export default Trct_FotoAngolareTuoVeicoloPage